import * as React from 'react';
import type { IImperativeControlBase } from '@fluentui-copilot/chat-input-plugins';
import { ImperativeControlBase } from '@fluentui-copilot/chat-input-plugins';
import { useLexicalComposerContext } from '@fluentui-copilot/react-text-editor';

export type ImperativeControlPluginRef = IImperativeControlBase;
export type ImperativeControlPluginProps = {};

export const ImperativeControlPlugin = React.forwardRef<ImperativeControlPluginRef, ImperativeControlPluginProps>(
  (_props, ref) => {
    const [editor] = useLexicalComposerContext();

    React.useImperativeHandle(ref, () => new ImperativeControlBase(editor), [editor]);

    return null;
  },
);
